import React from 'react';

import { CategoryItem } from 'ggApp/types/api/CategoryItem';
import { getCategoryFilterSuffix } from 'ggApp/utils/urlBuilder/getCategoryFilterSuffix';

import { Icon, Name, Wrap } from './styled';

type ItemProps = {
    onClick?: () => void;
    isEUNonBusinessStore: boolean;
    subcategory: CategoryItem;
};

export const Item = ({
    onClick = () => undefined,
    isEUNonBusinessStore,
    subcategory,
}: ItemProps) => {
    // eslint-disable-next-line camelcase
    const { name, icon_svg_path: iconPath } = subcategory;

    return (
        <Wrap
            external={false}
            to={`${subcategory.permalink}${getCategoryFilterSuffix(
                subcategory,
                isEUNonBusinessStore,
            )}`}
            onClick={onClick}
            type="catalog-link"
        >
            {iconPath !== undefined && <Icon iconPath={iconPath} />}
            <Name>{name}</Name>
        </Wrap>
    );
};
